import EducationLevel from 'modules/contracts/store/models/EducationLevel'

import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class EducationLevels extends PayrollLegalEntityResource<EducationLevel> {
  get cacheKey(): string {
    return 'educationLevels'
  }

  model() {
    return EducationLevel
  }
}

export { EducationLevels }
